import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
export class CertificadosFsViewModel {
    public IdSolicitud: number;
    public CodigoSolicitud: string;
    public NumeroCertificado: string;
    public EstadoSolicitudExDescripcion: string;
    public EstadoCfDescripcion: string;
    public CfUtilizado: boolean;
    public CfDisponible: boolean;
}
export class CertificadosFsItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: CertificadosFsItemViewModel[];
}

export class CertificadosFsItemViewModel {
    public IdSolicitud: number;
    public Codigo: string;
    public NumeroCertificado: string;
    public IdEstadoSolicitudEx: number;
    public EstadoSolicitudExDescripcion: string;
    public IdTipoSolicitudEx: number;
    public CodigoTipoSolicitud: number;
    public TipoSolicitudExDescripcion: string;
    public IdEstadoCf: number;
    public EstadoCfDescripcion: string;
    public IdPuntoInspeccion: number;
    public PuntoInspeccionDescripcion: string;
    public IdPaisDestinoDescripcion: string;
    public Exportador: string;
    public NifExportador: string;
    public Importador: string;
    public NifImportador: string;
    public Utilizado: boolean;
    public Disponible: boolean;
    public IdPaisDestino: number | null;
}

export class FilterSearchingCertificadosFsViewModel extends FilterSearchingBaseViewModel {
    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {
        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.FechaDesde = this.firstDayMonth;
        this.FechaHasta = this.lastDayMonth;
    }

    public Codigo: string;
    public NumeroCertificado: string;
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public IdTipoSolicitudEx: number | null;
    public IdPuntoInspeccion: number | null;
    public IdPaisDestino: number | null;
    public IdSolicitud: number | null;
    public IdEstadoSolicitudEx: number | null;
    public IdEstadoCf: number | null;
    public Utilizado: number = EnumSiNoTodos.TODOS;
    public Disponible: number = EnumSiNoTodos.TODOS;
    public NifExportador: string;
    public NifImportador: string;
}
